import { Directive, ElementRef, HostBinding, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { HelpTargetRegistryService } from '../services/help-target-registry.service';

@Directive({
  selector: '[helpTarget]',
  standalone: true,
})
export class HelpTargetDirective implements OnChanges, OnDestroy {
  @Input('helpTarget') targetKey = '';

  /** DOM fallback when the registry lookup races ahead of registration or misses reconnects. */
  @HostBinding('attr.data-help-target')
  get dataHelpTargetAttr(): string | null {
    return this.targetKey?.trim() ? this.targetKey : null;
  }

  constructor(
    private readonly el: ElementRef<HTMLElement>,
    private readonly registry: HelpTargetRegistryService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['targetKey']) {
      this.registry.unregister(changes['targetKey'].previousValue);
      if (this.targetKey) {
        this.registry.register(this.targetKey, this.el.nativeElement);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.targetKey) {
      this.registry.unregister(this.targetKey);
    }
  }
}
